import { ToastContentProps } from 'react-toastify';

import CloseIcon from '@mui/icons-material/Close';
import { Box, Typography, IconButton } from '@mui/joy';

interface ToastData {
  message: string;
}

const CrewToast = ({ closeToast, toastProps }: ToastContentProps<ToastData>) => {
  const data = toastProps?.data;
  const message =
    data && typeof data === 'object' && 'message' in data && typeof data.message === 'string' ? data.message : '';
  return (
    <Box
      className='min-w-fit max-w-90vw flex items-center px-2 py-3 justify-between rounded-md gap-2'
      sx={{
        backgroundColor: 'common.black',
        backdropFilter: 'blur(10px)',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)'
      }}
    >
      <Box className='flex items-center gap-2'>
        <Typography
          level='body-md'
          className='min-w-0 overflow-hidden text-ellipsis whitespace-nowrap'
          sx={{
            color: 'neutral.300'
          }}
        >
          {message}
        </Typography>
      </Box>
      <IconButton
        size='sm'
        variant='plain'
        onClick={closeToast}
        sx={{
          color: 'primary.offWhite',
          colorOpacity: 0.7,
          '&:hover': {
            backgroundColor: 'color-mix(in srgb, var(--joy-palette-background-level1) 10%, transparent)',
            color: 'primary.focusVisible'
          }
        }}
      >
        <CloseIcon style={{ width: 16, height: 16 }} />
      </IconButton>
    </Box>
  );
};

export default CrewToast;
